import EmptyComponent from './Empty';
import ErrorComponent from './Error';
import LoadingComponent from './Loading';

export default {
  Error: ErrorComponent,
  Empty: EmptyComponent,
  Loading: LoadingComponent,
};
